<template>
  <div class="container mt-4">
    <h2>{{ $t("financial.global.newsale") }}</h2>

    <div class="top-menu">
      <BaseInputLogic
        style="margin-bottom: 13px"
        :options="menu.options"
        :value.sync="menu.value"
        @onDataChange="handleInputChange(menu.value)"
      ></BaseInputLogic>
    </div>

    <div v-if="menu.value == '1'">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col cols="9">
            <b-form-group label-for="code" label="Cód. Venda">
              <b-form-input
                v-model="sale.code"
                type="text"
                id="code"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label-for="status" label="Status">
              <b-form-select
                v-model="sale.status"
                :options="statusOptions"
                id="status"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label-for="client" label="Cliente">
              <b-form-select
                v-model="sale.client.id"
                :options="clients"
                id="client"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="seller" label="Vendedor">
              <b-form-select
                v-model="sale.seller.id"
                :options="sellers"
                id="seller"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="4">
            <b-form-group label-for="client" label="Categoria financeira">
              <b-form-select
                v-model="sale.client.id"
                :options="clients"
                id="client"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="estimateDate" label="Data Venda">
              <b-form-input
                v-model="sale.dates.saleDate"
                type="date"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="forecast" label="Previsão">
              <b-form-input
                v-model="sale.dates.forecast"
                type="date"
                id="forecast"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group label-for="notes" label="Observações">
              <b-form-textarea
                v-model="sale.notes"
                id="notes"
                required
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <h3>Itens da venda</h3>

        <b-row>
          <b-col cols="12">
            <b-form-group label-for="product" label="Produto/Serviço">
              <b-form-select
                v-model="newItem.product"
                id="product"
                :options="marketItems"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="4">
            <b-form-group label-for="quantity" label="Quantidade">
              <b-form-input
                v-model.number="newItem.quantity"
                id="quantity"
                type="number"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="unitPrice" label="Valor Unitário">
              <b-form-input
                v-model.number="newItem.unitPrice"
                type="number"
                id="unitPrice"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="calculateTotal" label="Valor Total">
              <b-form-input
                v-model="calculateTotal"
                type="text"
                id="calculateTotal"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ag-theme-alpine-dark" style="height: 250px;">
            <ag-grid-vue
              style="width: 100%; height: 100%;"
              :columnDefs="columnDefs"
              :rowData="items"
              @grid-ready="onGridReady"
              @selection-changed="onSelectionChanged"
              @cell-value-changed="onCellValueChanged"
              :rowSelection="'multiple'"
              :defaultColDef="defaultColDef"
              rowHeight="40"
              :pagination="true"
            ></ag-grid-vue>
          </b-col>
        </b-row>

        <b-button
          v-if="!isEditing"
          @click="addItem"
          variant="primary"
          size="sm"
        >
          Adicionar Item
        </b-button>

        <b-button v-else @click="updateItem" variant="warning" size="sm">
          Atualizar Item
        </b-button>

        <b-button
          v-if="showEdit"
          variant="primary"
          style="width: 40px;"
          size="sm"
          @click="editItem"
        >
          <i class="tim-icons icon-pencil"></i>
        </b-button>

        <b-button
          v-if="showDelete"
          variant="danger"
          style="width: 40px;"
          size="sm"
          @click="removeItem"
        >
          <i class="tim-icons icon-trash-simple"></i>
        </b-button>

        <b-row>
          <b-col cols="2">
            <b-form-group label-for="discountType" label="Tipo Desconto">
              <b-form-select
                v-model="sale.discount.type"
                id="discountType"
                :options="discountTypes"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="5">
            <b-form-group label-for="discountValue" label="Desconto">
              <b-form-input
                v-model="sale.discount.value"
                id="discountValue"
                type="number"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="5">
            <b-form-group label-for="discountValue" label="Frete">
              <b-form-input
                v-model="sale.total.freightValue"
                id="discountValue"
                type="number"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <h3>Total da venda</h3>

        <b-row class="text-center">
          <b-col>
            <h5>Itens Orçamento</h5>
            <h4 style="color: #9cff19">R${{ sale.total.itemsTotal }}</h4>
          </b-col>

          <span>-</span>

          <b-col>
            <h5>Desconto</h5>
            <h4 style="color: #ff4619">R${{ sale.total.discountValue }}</h4>
          </b-col>

          <span>+</span>

          <b-col>
            <h5>Frete</h5>
            <h4 style="color: #ffc600">R${{ sale.total.freightValue }}</h4>
          </b-col>

          <span>=</span>

          <b-col>
            <h5>Valor Total</h5>
            <h4>R${{ sale.total.finalTotal }}</h4>
          </b-col>
        </b-row>

        <hr />
        <h3>Pagamento</h3>

        <b-row>
          <b-col cols="6">
            <b-form-group label-for="paymentType" label="Forma de pagamento">
              <b-form-select
                v-model="sale.discount.type"
                id="paymentType"
                :options="paymentMethodsOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label-for="receivingAccount"
              label="Conta recebimento"
            >
              <b-form-select
                v-model="sale.discount.type"
                id="receivingAccount"
                :options="bankAccountsOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label-for="percent" label="Percentual">
              <b-form-input
                v-model="sale.estimateDate"
                type="number"
                id="percent"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="amountReceived" label="Valor a receber">
              <b-form-input
                v-model="sale.estimateDate"
                type="number"
                id="amountReceived"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label-for="conditions" label="Condições">
              <b-form-select
                v-model="sale.conditions"
                id="conditions"
                :options="paymentConditionOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="dueDate" label="Vencimento">
              <b-form-input
                v-model="sale.installmentValidity"
                type="date"
                id="dueDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-button
              variant="primary"
              class="mt-3"
              size="sm"
              @click="togglePanel"
            >
              Editar Parcelas
            </b-button>
          </b-col>
        </b-row>
        <SaleSidePanel
          :isPanelOpen="openPanel"
          :totalAmount="sale.total.finalTotal"
          :installments="sale.installments"
          @close-saleSidepanel="togglePanel"
        ></SaleSidePanel>

        <b-button type="submit" variant="primary">Cadastrar</b-button>

        <fade-alert-danger
          ref="fadeAlertDanger"
          :msg="alert.error"
        ></fade-alert-danger>
        <success-fade-alert
          ref="successFadeAlert"
          :msg="alert.success"
        ></success-fade-alert>
      </b-form>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import BaseInputLogic from "@/components_rms/base/BaseImputLogic.vue";
import SaleSidePanel from "../../Components/SaleSidePanel.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  name: "SaleCrud",
  alert: {
    error: "Verifique os dados informados",
    success: "Venda cadastrada com sucesso!"
  },
  components: {
    AgGridVue,
    BaseInputLogic,
    SaleSidePanel,
    FadeAlertDanger,
    SuccessFadeAlert
  },
  data() {
    return {
      openPanel: false,
      sale: {
        code: "",
        status: "",
        client: { id: "", code: "" },
        seller: { id: "", code: "" },
        paymentCategory: "",
        dates: {
          saleDate: "2025-02-07",
          forecast: ""
        },
        notes: "",
        items: [
          {
            productOrService: "",
            quantity: 0,
            unitPrice: 0,
            totalPrice: 0
          }
        ],
        discount: {
          value: 0,
          type: "valor"
        },
        total: {
          itemsTotal: 0,
          discountValue: 0,
          freightValue: 0,
          finalTotal: 0
        },
        paymentMethods: 0,
        receiptAccountId: 0,
        percent: 100,
        receivedAmount: 0,
        conditions: 0,
        installmentValidity: "",
        installments: []
      },
      newItem: {
        product: "",
        quantity: 1,
        unitPrice: 0
      },
      items: [],
      columnDefs: [
        {
          checkboxSelection: true,
          headerName: "Produto/Serviço",
          field: "product",
          sortable: true
        },
        {
          headerName: "Quantidade",
          field: "quantity",
          sortable: true
        },
        {
          headerName: "Valor Unitário",
          field: "unitPrice",
          sortable: true
        },
        { headerName: "Valor Total", field: "total", sortable: true }
      ],
      defaultColDef: {
        resizable: true,
        flex: 1
      },
      statusOptions: [
        { value: "", text: "Em Andamento" },
        { value: "pendente", text: "Pendente" },
        { value: "aprovado", text: "Aprovado" }
      ],
      clients: [{ value: "", text: "Selecione um cliente" }],
      sellers: [{ value: "", text: "Selecione um vendedor" }],
      marketItems: [{ value: "", text: "Selecione um item" }],
      discountTypes: [
        { value: "percentual", text: "%" },
        { value: "valor", text: "R$" }
      ],
      paymentConditionOptions: [],
      paymentMethodsOptions: [
        { value: "0", text: "Pix" },
        { value: "1", text: "Boleto" },
        { value: "2", text: "Cartão de crédito" },
        { value: "3", text: "Cartão de débito" },
        { value: "4", text: "Cartão digital" },
        { value: "5", text: "Dinheiro" }
      ],
      bankAccountsOptions: [{ value: "1", text: "Banco 01" }],
      gridOptions: {
        onGridReady: this.onGridReady
      },
      showDelete: false,
      showEdit: false,
      isEditing: false,
      menu: {
        options: [
          { value: "1", text: "Venda única" },
          { value: "2", text: "Venda Programada" }
        ],
        value: "1"
      }
    };
  },
  created() {
    if (this.$route.query.sale) {
      const getEstimate = JSON.parse(this.$route.query.sale);
      this.sale = getEstimate;
    }
    this.generatePaymentOptions();
  },
  computed: {
    calculateTotal() {
      return (this.newItem.quantity * this.newItem.unitPrice).toFixed(2);
    }
  },
  watch: {
    "sale.discount.value": function() {
      this.updateTotals();
    },
    "sale.discount.type": function() {
      this.updateTotals();
    },
    "newItem.quantity": function() {
      this.updateFormTotal();
    },
    "newItem.unitPrice": function() {
      this.updateFormTotal();
    }
  },

  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },

    onRowClicked(event) {
      const rowData = event.data;
      this.$router.push({
        name: "EstimateCrud",
        query: rowData
      });
    },
    addItem() {
      const newItem = {
        product: this.newItem.product,
        quantity: this.newItem.quantity,
        unitPrice: this.newItem.unitPrice,
        total: (this.newItem.quantity * this.newItem.unitPrice).toFixed(2)
      };

      this.items.push(newItem);
      this.updateTotals();
      this.newItem = {
        product: "",
        quantity: 1,
        unitPrice: 0
      };
    },
    removeItem(node) {
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map(node => node.data);
      this.items = this.items.filter(row => !selectedData.includes(row));
      this.updateTotals();
      this.gridApi.deselectAll();
    },
    editItem() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      if (selectedNodes.length !== 1) return;

      const selectedData = selectedNodes[0].data;
      this.newItem = { ...selectedData };
      this.isEditing = true;
    },
    updateItem() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      if (selectedNodes.length !== 1) return;

      const selectedData = selectedNodes[0].data;
      const index = this.items.findIndex(item => item === selectedData);

      if (index !== -1) {
        this.items[index] = { ...this.newItem };
        this.gridApi.setRowData(this.items);
      }
      this.updateTotals();
      this.newItem = {
        product: "",
        quantity: 1,
        unitPrice: 0
      };
      this.gridApi.deselectAll();
      this.isEditing = false;
    },
    updateTotals() {
      if (this.sale.total) {
        this.sale.total.itemsTotal = this.items
          .reduce((sum, item) => sum + parseFloat(item.total), 0)
          .toFixed(2);

        if (this.sale.discount.type === "percentual") {
          this.sale.total.discountValue = (
            (this.sale.discount.value / 100) *
            this.sale.total.itemsTotal
          ).toFixed(2);
        } else {
          this.sale.total.discountValue = parseFloat(
            this.sale.discount.value
          ).toFixed(2);
        }

        this.sale.total.finalTotal = (
          this.sale.total.itemsTotal -
          this.sale.total.discountValue +
          parseFloat(this.sale.total.freightValue)
        ).toFixed(2);
      }
    },
    updateFormTotal() {
      this.newItem.total = (
        this.newItem.quantity * this.newItem.unitPrice
      ).toFixed(2);
    },
    onSelectionChanged() {
      if (!this.gridApi) return;
      this.showDelete = this.gridApi.getSelectedNodes().length > 0;
      this.showEdit = this.gridApi.getSelectedNodes().length == 1;
    },
    onCellValueChanged(params) {
      if (
        params.column.colId === "quantity" ||
        params.column.colId === "unitPrice"
      ) {
        params.data.total = (
          params.data.quantity * params.data.unitPrice
        ).toFixed(2);
        this.updateTotals();
        this.gridApi.refreshCells({ force: true });
      }
    },
    handleInputChange(newValue) {
      this.fetchData();
      if (newValue == null) {
        this.menu.value = this.previousMenuValue;
      } else {
        this.previousMenuValue = newValue;
      }
    },
    generatePaymentOptions() {
      this.paymentConditionOptions = [
        { value: "100", text: "A Vista" },
        { value: "306090", text: "30,60,90" },
        { value: "153045", text: "15,30,45" },
        { value: "2", text: "2x" }
      ];

      const maxInstallments = 72;
      for (let i = 3; i <= maxInstallments; i++) {
        this.paymentConditionOptions.push({ value: `${i}`, text: `${i}x` });
      }
    },
    togglePanel() {
      this.sale.installments = this.generateInstallments(
        this.sale.total.finalTotal,
        this.sale.conditions,
        this.sale.installmentValidity
      );
      this.openPanel = !this.openPanel;
    },
    generateInstallments(totalAmount, installmentCount, firstDueDate) {
      const installments = [];
      const installmentValue = (totalAmount / installmentCount).toFixed(2);
      const installmentPercent = (100 / installmentCount).toFixed(2);

      let currentDueDate = new Date(firstDueDate);

      for (let i = 1; i <= installmentCount; i++) {
        installments.push({
          installmentNumber: i,
          installmentValue: parseFloat(installmentValue),
          initialStateValue: parseFloat(installmentValue),
          installmentPercent: parseFloat(installmentPercent),
          initialStatePercent: parseFloat(installmentPercent),
          dueDate: currentDueDate.toISOString().split("T")[0],
          observations: `Parcela ${i} de ${installmentCount}`
        });

        currentDueDate.setMonth(currentDueDate.getMonth() + 1);
      }

      if (installments.length > 0) {
        const totalPercent = installments
          .slice(0, -1)
          .reduce(
            (acc, installment) => acc + installment.installmentPercent,
            0
          );

        installments[installments.length - 1].installmentPercent = Math.max(
          0,
          (100 - totalPercent).toFixed(2)
        );
      }

      return installments;
    }
  }
};
</script>

<style>
.ag-theme-alpine-dark .ag-root {
  background-color: #1e1e2f !important;
}

.ag-theme-alpine-dark .ag-header,
.ag-theme-alpine-dark .ag-header-cell-label {
  background-color: #1e1e2f;
  color: #ffffffb3 !important;
  font-family: "Poppins";
  font-size: 12px;
}
.ag-theme-alpine-dark {
  border: none !important;
  background-color: #1e1e2f !important;
}

.ag-theme-alpine-dark .ag-root-wrapper {
  background-color: #1e1e2f;
  border: none !important;
}
.ag-theme-alpine-dark .ag-row {
  background-color: #1e1e2f !important;
}
.top-menu {
  display: flex;
  gap: 10px;
}
</style>
